import React, { Component } from "react";

import {
  Wrapper,
  Row,
  Copy,
  Spin,
  Icon,
  Animation
} from "app/NativeComponents/common";

class MessageDisplayItem extends Component {
  renderIcon() {
    const { message, colors } = this.props;

    if (message.skipped) {
      return (
        <Wrapper
          style={{
            margin: 10,
            marginLeft: 0,
            marginBottom: 10,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Icon size={18} icon="check-circle" />
        </Wrapper>
      );
    }

    if (message.success) {
      return (
        <Wrapper
          style={{
            margin: 10,
            marginLeft: 0,
            marginBottom: 10,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Icon size={18} icon="check-circle" color={colors.success_color} />
        </Wrapper>
      );
    }

    if (message.failure) {
      return (
        <Wrapper
          style={{
            margin: 10,
            marginLeft: 0,
            marginBottom: 10,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Icon size={18} icon="error" />
        </Wrapper>
      );
    }

    return (
      <Wrapper
        style={{
          margin: 10,
          marginLeft: 0,
          marginBottom: 10,
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Spin size={"small"} />
      </Wrapper>
    );
  }

  render() {
    const { message, colors } = this.props;

    if (message) {
      return (
        <Animation
          style={{ alignSelf: "stretch" }}
          type={
            message.skipped || message.success || message.failure
              ? "fadeOutUp"
              : "fadeInUp"
          }
          duration={1000}
          delay={
            message.skipped || message.success
              ? 1000
              : message.failure
              ? 5000
              : 0
          }
        >
          <Row style={{ justifyContent: "flex-end", alignItems: "center" }}>
            <Wrapper>
              <Wrapper
                style={{
                  margin: 10,
                  marginBottom: 5,
                  marginLeft: 30,
                  padding: 15,
                  backgroundColor: message.success
                    ? colors.success_color_muted
                    : message.failure
                    ? colors.error_color_muted
                    : colors.card_color,
                  borderRadius: 5
                }}
              >
                <Copy
                  style={{
                    color: colors.text_color
                  }}
                >
                  {message.skipped ? "Message Skipped" : message.message_text}
                </Copy>
              </Wrapper>
              <Wrapper
                style={{
                  margin: 10,
                  marginTop: 0,
                  marginBottom: 0,
                  alignItems: "flex-end"
                }}
              >
                <Copy style={{ color: colors.light_text_color, fontSize: 10 }}>
                  {!message.skipped
                    ? message.success
                      ? "Sent to " + message.lead_phone_number
                      : message.failure
                      ? !!message.failure_message
                        ? message.failure_message
                        : "Failed To Send"
                      : "Sending to " + message.lead_phone_number + "..."
                    : ""}
                </Copy>
              </Wrapper>
            </Wrapper>
            {this.renderIcon()}
          </Row>
        </Animation>
      );
    }
  }
}

export default MessageDisplayItem;
